import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment-timezone';
import { Box, Typography } from '@material-ui/core';
import { IModificationHistory, RevisionType } from 'common/components/PersonProfile/interfaces';
import { ITableRow } from 'common/interfaces/table';
import { Table } from 'common/components';
import messages from 'modules/booking/messages';
import { DEFAULT_DATE_FORMAT } from 'common/constants/dateFormats';

interface IModificationHistoryProps {
  eventHistory: IModificationHistory[];
}

const ModificationHistory: FC<IModificationHistoryProps> = ({ eventHistory }) => {
  const createRows = (): ITableRow[] =>
    eventHistory.map(
      (historyItem): ITableRow => ({
        id: `${historyItem.revisionId}`,
        cells: [
          {
            label: '',
            cellComponent: (
              <Typography variant="h5">
                <FormattedMessage
                  {...(historyItem.revisionType === RevisionType.ADD
                    ? messages.eventCreateChangeTypeLabel
                    : messages.eventEditChangeTypeLabel)}
                />
              </Typography>
            ),
          },
          { label: `${moment(historyItem.timestamp).format(DEFAULT_DATE_FORMAT)}` },
          {
            label: historyItem.lastModifiedBy?.title || '',
          },
        ],
      }),
    );

  return (
    <Box>
      <Typography variant="button" color="textSecondary">
        <FormattedMessage {...messages.modificationHistory} />
      </Typography>

      <Table rows={createRows()} isLoading={false} hidePagination hideToolbar hideSearchInput />
    </Box>
  );
};

export default ModificationHistory;
